import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import type { WaHideEvent } from '@web.awesome.me/webawesome-pro';

/**
 * App-root dialog for the backend's workspace_membership_inactive 403 (the
 * session's workspace claim no longer matches live membership). The only exit
 * is signing in again, which mints a token with a valid claim, so Escape and
 * light dismiss are blocked while the prompt is active.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-membership-inactive-dialog',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './membership-inactive-dialog.html',
})
export class MembershipInactiveDialog {
    readonly auth = inject(AuthService);

    onHide(e: WaHideEvent) {
        // Block Escape / light dismiss while active; allow the programmatic
        // close when confirmMembershipInactive() clears the signal.
        if (this.auth.membershipInactive()) {
            e.preventDefault();
        }
    }

    onSignIn() {
        this.auth.confirmMembershipInactive();
    }
}
